module.exports = __webpack_public_path__ + "img/20191230155641360截图20191230104708607.7c4b0e53.jpg";